namespace Gordic.Adm.WebControls {
    export interface IGAdmHromadnaOperaceOptions {
        title: string;
        data: any[];
        objectFields: string[];
        serviceCnt: string;
        keys: string[];
        contentId: string;
        editMode?: boolean;
        updateExist?: boolean;
        formSettings?: {
            aktivitaField?: boolean,
            datOdDoField?: boolean
        }
        hromadneZmenyFields?: {
            fieldName: string,
            caption: string,
            items: string[]
        }[]
    }

    export const OptionsHromadnaOperaceDefaults: IGAdmHromadnaOperaceOptions = {
        title: "",
        data: [],
        objectFields: [],
        serviceCnt: "",
        keys: [],
        contentId: "",
        editMode: false,
        updateExist: false,
        formSettings: {
            aktivitaField: true,
            datOdDoField: false
        },
        hromadneZmenyFields: []
    }
}